import { IContract } from './contract.interface';

export interface IDocument {
  id: number;
  role: string;
  contract: IContract;
  accessToken: string;
}
